/* eslint-disable import/order */
import React from 'react';
import { Box, Link, styled, useMediaQuery } from '@mui/material';
import { func, number, shape } from 'prop-types';
import { useParams } from 'react-router-dom';

// styles
import {
  chevronRightStyles,
  chipStylesSelectedStyles,
  chipStylesStyles,
  flexRowStyles,
  labelStyles,
  linkStyles,
  // listItemHeaderContainerStyles,
  selectedListItemStyles,
  titleStyles,
} from './Selector.styles';

// Components
import { ChevronRightRounded } from '@mui/icons-material';

// helpers
import { getSelectionURI } from 'utils/helpers/url';
import { useTheme } from '@mui/material/styles';

const ListItemHeaderContainerStyles = styled(Link)({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
});

const Selector = ({
  selectedIndex,
  data,
  index,
  resetCardFilters,
  setCarrierAuthorizationsPending,
  setFilters,
  setHeaderSubtitle,
  setMobileDrawerOpen,
  style,
}) => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
  const { viewBy } = useParams();

  const { activeAuthorizationsCount, authorizationCount, carrierName, fein, nameShort } =
    data.selectorsData[index];

  const handleOnClick = idx => {
    setFilters({ name: 'selectedIndex', value: idx });
    resetCardFilters();
    fein && setHeaderSubtitle(fein);
    setCarrierAuthorizationsPending(true);
    if (!lgUp) {
      setMobileDrawerOpen(true);
    }
  };

  return (
    <ListItemHeaderContainerStyles
      key={carrierName || nameShort}
      onClick={() => handleOnClick(index)}
      style={style}
      sx={{
        ...linkStyles(theme),
        ...(index === selectedIndex ? selectedListItemStyles(theme) : {}),
      }}
      to={`../carrier-authorizations/${viewBy}/${getSelectionURI(data.selectorsData[index])}`}
    >
      <Box sx={{ alignItems: 'flex-end', display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={titleStyles(theme)}>{carrierName || nameShort}</Box>
        <ChevronRightRounded sx={chevronRightStyles(theme)} />
      </Box>
      <Box sx={{ ...flexRowStyles }}>
        <span
          style={
            index === selectedIndex ? chipStylesSelectedStyles(theme) : chipStylesStyles(theme)
          }
        >
          {authorizationCount || activeAuthorizationsCount}
        </span>
        <Box sx={{ ...labelStyles(theme) }}>Carrier Authorizations</Box>
      </Box>
    </ListItemHeaderContainerStyles>
  );
};

Selector.propTypes = {
  data: shape({}).isRequired,
  index: number.isRequired,
  resetCardFilters: func.isRequired,
  selectedIndex: number,
  setCarrierAuthorizationsPending: func.isRequired,
  setFilters: func.isRequired,
  setHeaderSubtitle: func.isRequired,
  setMobileDrawerOpen: func.isRequired,
  style: shape({}),
};

Selector.defaultProps = {
  selectedIndex: undefined,
  style: {},
};

export default Selector;
